// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ca-0";